import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Typography, Box } from '@mui/material'

function PrefilledSection({ show, children, ...boxProps }) {
  const { t } = useTranslation('order_detail')
  return (
    <Box sx={show ? {
      position: 'relative',
      border: '2px solid',
      borderColor: 'primary.light',
      borderRadius: '4px',
      p: 2,
      pt: 2.5,
    } : {}} {...boxProps}>
      {show && (
        <Typography
          sx={{
            position: 'absolute',
            top: '-10px',
            left: '16px',
            bgcolor: '#fff',
            px: 1,
            fontSize: '0.75rem',
            color: 'primary.main',
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}
        >
          {t('infoFromCommand')}
        </Typography>
      )}
      {children}
    </Box>
  )
}

PrefilledSection.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node,
}

export default PrefilledSection
